import type { TranslationKey } from './en';
import core from '../bundles/te/core';
import workspace from '../bundles/te/workspace';
import settings from '../bundles/te/settings';

const te: Record<TranslationKey, string> = { ...core, ...workspace, ...settings };

export default te;
